// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";
import SalesAssociateWashoutsLayer from "@/Washouts/views/Layers/Sales/Associates/SalesAssociateWashoutsLayer";

export default function SalesAssociateWashout() {
	const Icon = getOutlinedPositionIcon({ position: "Sales Associate" });
	return (
		<PageLayer title={"Sales Associates Washouts"} icon={Icon}>
			<SalesAssociateWashoutsLayer />
		</PageLayer>
	);
}
